import {
  NBS_WS_AUTH_DONE_RECEIVED,
  NBS_WS_COUNTERS_RECEIVED,
  NBS_WS_FLIRTS_UPDATE_RECEIVED,
  NBS_WS_ITS_MATCH_RECEIVED,
  NBS_WS_VIP_UPDATE,
  NBS_WS_GET_CHAT_HISTORY,
  NBS_WS_GET_CHAT_HISTORY_SUCCESS,
  NBS_WS_GET_MESSAGE_SUCCESS,
  NBS_WS_SEND_MESSAGE,
  NBS_WS_SEND_MESSAGE_SUCCESS,
  NBS_WS_SEND_MESSAGE_FAIL,
  NBS_WS_GET_USER_DATA,
  NBS_WS_USER_DATA,
  NBS_WS_SEND_TYPING,
  NBS_WS_GET_TYPING,
  USER_NOT_TYPING,
  NBS_WS_SET_READ,
  NBS_WS_PRIVATE,
  NBS_WS_STOP_AND_DONT_RECONNECT,
  RESET_STOP_AND_DONT_RECONNECT,
  SET_MISSING_PHOTO_MODAL,
  RESET_MISSING_PHOTO_MODAL,
  NBS_WS_INVALID_TOKEN,
  NBS_WS_AUTH_BLOCKED,
  INVALID_SOCKET_AUTH,
  DELETE_ACTION_REQUIRED,
  NBS_WS_VIP_3DSV2_UPDATE_SUCCESS,
  NBS_WS_3DSV2_UPDATE_FAILED,
  NBS_WS_3DSV2_UPDATE_PROCESSING,
  RESET_WS_3DSV2_UPDATE_PROCESSING,
  DELETE_ALL_ACTIONS_REQUIRED,
  DELETE_CHAT,
} from '../../constants/actions';
import config from '../../constants/config';
import ReconnectingWebSocket from '../../assets/libs/reconnect-websocket/reconnect-websocket';

const WebSocket = window.WebSocket || window.MozWebSocket;
const socketOptions = {
  WebSocket,
  reconnectInterval: 2000,
  reconnectDecay: 1.1,
};
let socket;
let currentUserChatroom;
let counters;

export function setCurrentUserChatroom(userId) {
  currentUserChatroom = userId;
}
export function getCurrentUserChatroom() {
  return currentUserChatroom;
}

export function nbsWSConnect(token) {
  // socket = new WebSocket(config.NBS_WS_API_URL);
  socket = new ReconnectingWebSocket(config.NBS_WS_API_URL, [], socketOptions);
  return (dispatch) => {
    socket.onopen = async () => {
      // console.log('ON SOCKET OPEN');

      if (socket) {
        socket.onmessage = (e) => {
          let data;
          try {
            data = JSON.parse(e.data);
          } catch (err) {
            return;
          }
          // console.log('ON SERVER MESSAGE !!!!!!!!! :::', data);

          if (data.event === 'auth_done') {
            // for testing

            // const obj = { actions_required: ['upload_photo', 'update_sex'] };
            // const obj = { actions_required: ['upload_photo'] };
            // const obj = {
            //   actions_required: ['upload_photo', 'show_nearby_connect_dialog'],
            // };
            // const obj = {
            //   actions_required: ['show_postponed_upgrade', 'upload_photo'],
            // };
            // const obj = { actions_required: ['show_special_offer_2x'] };
            // const obj = {
            //   actions_required: [
            //     'update_tag_line',
            //     'upload_photo',
            //     'show_initial_offer',
            //   ],
            // };

            // const obj = { actions_required: ['need_explicit_opt_in'] };
            // const obj = {
            //   actions_required: [
            //     'show_nearby_connect_dialog',
            //     'email_confimation_needed',
            //   ],
            // };
            // dispatch({
            //   type: NBS_WS_AUTH_DONE_RECEIVED,
            //   data: {
            //     ...data,
            //     actions_required: [
            //       ...data.actions_required,
            //       ...obj.actions_required,
            //     ],
            //   },
            // });

            dispatch({ type: NBS_WS_AUTH_DONE_RECEIVED, data });
          } else if (data.event === 'counters') {
            // counters var needed for Chats red-dot hack when in chat-room with current user
            counters = data.counters;
            dispatch({ type: NBS_WS_COUNTERS_RECEIVED, data: data.counters });
          } else if (data.event === 'flirts_update') {
            dispatch({ type: NBS_WS_FLIRTS_UPDATE_RECEIVED, data });
          } else if (data.event === 'user_data') {
            dispatch({ type: NBS_WS_USER_DATA, data: data.data }); // store user data
            data.new_match === true &&
              dispatch({ type: NBS_WS_ITS_MATCH_RECEIVED, data: data.data });
          } else if (data.event === 'vip_update') {
            dispatch({ type: NBS_WS_VIP_UPDATE, data });
          } else if (data.event === '3dsv2_update_processing') {
            dispatch({ type: NBS_WS_3DSV2_UPDATE_PROCESSING });
          } else if (data.event === '3dsv2_update_success') {
            // console.log('SOCKET ACTION 3dsv2_update_success', data);
            dispatch({ type: NBS_WS_VIP_3DSV2_UPDATE_SUCCESS, data });
          } else if (data.event === '3dsv2_update_failed') {
            dispatch({ type: NBS_WS_3DSV2_UPDATE_FAILED, data });
          } else if (data.event === 'chat_history') {
            dispatch({ type: NBS_WS_GET_CHAT_HISTORY_SUCCESS, data });
          } else if (data.event === 'message') {
            data.updateRedDot = currentUserChatroom !== data.user_id;
            // hack to remove red-dot from Chats tab wne in a chat-room with current user
            if (
              currentUserChatroom === data.user_id &&
              counters.unseen_chats === 1
            ) {
              counters.unseen_chats = 0;
              dispatch({ type: NBS_WS_COUNTERS_RECEIVED, data: counters });
            } else if (
              currentUserChatroom !== data.user_id &&
              counters.unseen_chats === 0
            ) {
              counters.unseen_chats = 1;
              dispatch({ type: NBS_WS_COUNTERS_RECEIVED, data: counters });
            }
            dispatch({ type: NBS_WS_GET_MESSAGE_SUCCESS, data });
          } else if (data.event === 'message_sent') {
            dispatch({ type: NBS_WS_SEND_MESSAGE_SUCCESS, data });
          } else if (data.event === 'message_fail') {
            dispatch({ type: NBS_WS_SEND_MESSAGE_FAIL, data });
          } else if (data.event === 'message_free_restriction') {
            dispatch({ type: NBS_WS_SEND_MESSAGE_FAIL, data });
          } else if (data.event === 'typing') {
            dispatch({ type: NBS_WS_GET_TYPING, data });
          } else if (data.event === 'stop_and_dont_reconnect') {
            dispatch({ type: NBS_WS_STOP_AND_DONT_RECONNECT });
            socket.close();
          } else if (data.event === 'invalid_token') {
            dispatch({ type: NBS_WS_INVALID_TOKEN, data });
          } else if (data.event === 'auth_blocked') {
            dispatch({ type: NBS_WS_AUTH_BLOCKED, data });
          } else if (data.event === 'private') {
            dispatch({ type: NBS_WS_PRIVATE, data });
          } else if (data.event === 'delete_chat') {
            dispatch({ type: DELETE_CHAT, data });
          }
        };

        if (socket.readyState === 0) {
          // wait until readyState changed from 0 (CONNECTING) to something else,
          // in most cases to 1 (OPEN). Required to make sure that we will not
          // send 'action': 'auth' until connected.
          // Added because I saw case when websocket connected, but 'action': 'auth' not sent
          // and in code I saw check "if (socket.readyState === 1) { /* send auth*/ }"
          await new Promise((resolve) => {
            let checkReadyStateTimer = setInterval(() => {
              if (socket && socket.readyState !== 0) {
                resolve();
                clearInterval(checkReadyStateTimer);
              }
            }, 100);
          });
        }

        socket.readyState === 1 &&
          socket.send(
            JSON.stringify({
              action: 'auth',
              platform: 'web',
              sess_token: token,
              push_enabled: true,
              language: 'en',
            })
          );
      }
    };

    socket.onclose = () => {
      // console.log('CLOSE WEBSOCKET!!!!');
    };

    socket.onerror = () => {
      // console.log('WEBSOCKET ERROR!!!!!!!', e);
    };
  };
}

export function nbsWSSend(data) {
  if (socket && socket.readyState === 1) {
    socket.send(JSON.stringify(data));
  } else if (!socket || (socket && socket.readyState !== 1)) {
    setTimeout(() => {
      socket && socket.readyState === 1 && socket.send(JSON.stringify(data));
    }, 3000);
  }
}

export function nbsWSClose() {
  if (socket) {
    socket.close();
    socket = null;
  }
}

export function nbsCloseSocket() {
  // console.log('CLOSE SOCKET');
  socket && socket.close();
}

/**
 * Send message to user
 * @param obj {"action":"message","user_id":"54c3a1a2ca439e9402d81669","type":"text | image", sub_type: "plain | jpeg, png", "msg":"Test message"}
 */
export function nbsWSSendMessage(userId, msgType, msgSubType, msg) {
  let action = 'message';
  nbsWSSend({
    action,
    user_id: userId,
    type: msgType,
    sub_type: msgSubType,
    msg,
  });
  return (dispatch) => {
    dispatch({ type: NBS_WS_SEND_MESSAGE });
  };
}

/**
 * Fetch chat messages with user
 * @param data {"action": "get_chat_history", "user_id": "54c1076e168ddb8f75c53aa4", "skip": 0, "from_mid": '54d1363ed7d86bd461b4ce6c', "limit": 15}
 */
export function nbsWSGetChatHistory(userId, fromMId = 'last') {
  nbsWSSend({
    user_id: userId,
    offset_mid: fromMId,
    add_offset: -50,
    limit: 50,
    action: 'get_chat_history',
  });

  return (dispatch) => {
    dispatch({ type: NBS_WS_GET_CHAT_HISTORY });
  };
}

/**
 * Get user data for specific user hash
 * @param hash userId
 */
export function nbsWSGetUserData(userId) {
  let action = 'get_user_data';
  nbsWSSend({ action, user_id: userId });
  return (dispatch) => {
    dispatch({ type: NBS_WS_GET_USER_DATA });
  };
}

/**
 * Send to server that you are typing message to user, not to be used more than 1 time in 2 seconds
 * @param hash userId   {"action": "typing", "user_id": '54c1076e168ddb8f75c53aa4'}
 */
export function nbsWSTyping(userId) {
  let action = 'typing';
  nbsWSSend({ action, user_id: userId });
  return (dispatch) => {
    dispatch({ type: NBS_WS_SEND_TYPING, data: { user_id: userId } });
  };
}
/**
 * Set user not typing
 * @param hash userId
 */
export function setUserNotTyping(userId) {
  return (dispatch) => {
    dispatch({ type: USER_NOT_TYPING, data: { user_id: userId } });
  };
}
/**
 * Set read for user_id
 * @param hash userId   {"action": "set_read", "user_id": '54c1076e168ddb8f75c53aa4'}
 */
export function nbsWSSetRead(userId) {
  let action = 'set_read';
  nbsWSSend({ action, user_id: userId });
  return (dispatch) => {
    dispatch({ type: NBS_WS_SET_READ, data: { user_id: userId } });
  };
}

export function resetStopAndDontReconnect() {
  socket && socket.open();
  return (dispatch) => dispatch({ type: RESET_STOP_AND_DONT_RECONNECT });
}

export function setMissingPhotoModal(data) {
  return (dispatch) => dispatch({ type: SET_MISSING_PHOTO_MODAL, data });
}

export function resetMissingPhotoModal() {
  return (dispatch) => dispatch({ type: RESET_MISSING_PHOTO_MODAL });
}

export function handleInvalidSocketAuth() {
  return (dispatch) => dispatch({ type: INVALID_SOCKET_AUTH });
}

export function deleteActionRequired(actionRequired) {
  return (dispatch) =>
    dispatch({
      type: DELETE_ACTION_REQUIRED,
      deleteActionRequired: actionRequired,
    });
}

export function reset3dsv2UpdaeProcessing() {
  return (dispatch) => dispatch({ type: RESET_WS_3DSV2_UPDATE_PROCESSING });
}

export function deleteAllActionsRequired() {
  return (dispatch) => dispatch({ type: DELETE_ALL_ACTIONS_REQUIRED });
}
